/** @format */

import React from "react";

import { Slider } from "primereact/slider";
// import { Tooltip } from "primereact/tooltip";
import ItemPlan from "../ItemPlan/ItemPlan";
import styles from "./PlansPricingLanding.module.scss";
import usePlansPricingLanding from "./usePlansPricingLanding";
import Form5000properties from "../Form5000properties/Form5000properties";

export default function PlansPricingLanding() {
	const {
		sliderValue,
		changeOptions,
		essentialsValue,
		//  premiumValue
	} = usePlansPricingLanding();

	return (
		<article className={styles.container}>
			<div className={styles.containerTitle}>
				<h1 className={styles.title}>Plans & Pricing</h1>
				<p className={styles.subtitle}>How many Properties do you manage?</p>
			</div>
			<div className={styles.containerSelectedPrice}>
				<div className={styles.conatainerSlider}>
					<Slider
						className="slider ml-3"
						value={sliderValue}
						onChange={(e) => changeOptions(e.value)}
						min={0}
						max={5000}
					/>
				</div>
			</div>
			{sliderValue === 5000 && <Form5000properties />}
			<div className={styles.containerItems}>
				<ItemPlan
					type={essentialsValue.type}
					price={essentialsValue.price}
					code={essentialsValue.code}
				/>
				{/* <ItemPlan type={premiumValue.type} price={premiumValue.price} code={premiumValue.code} /> */}
			</div>
		</article>
	);
}
